import axios from 'axios';
import paths from './path';

export const fetchWorkspaceLogo = async () => {
  const response = await axios.get(paths.workspaceBrandingLogo(), {
    headers: {
      Authorization: `${localStorage.getItem('token')}`,
    },
    responseType: 'blob',
    validateStatus: (status) => status === 200 || status === 204,
  });

  if (response.status === 204 || !response.data?.size) {
    return null;
  }

  return response.data;
};

export const uploadWorkspaceLogo = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.put(paths.workspaceBrandingLogo(), formData, {
    headers: {
      Authorization: `${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};

export const getDefaultPayCurrency = async () => {
  const response = await axios.get(paths.workspaceDefaultCurrency(), {
    headers: {
      Authorization: `${localStorage.getItem('token')}`,
    },
  });
  return response.data?.defaultCurrency || null;
};

export const updateDefaultPayCurrency = async (defaultCurrency) => {
  const response = await axios.put(
    paths.workspaceDefaultCurrency(),
    { defaultCurrency },
    {
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
      },
    }
  );
  return response.data?.defaultCurrency || null;
};

export const deleteWorkspaceLogo = async () => {
  const response = await axios.delete(paths.workspaceBrandingLogo(), {
    headers: {
      Authorization: `${localStorage.getItem('token')}`,
    },
  });

  return response.data;
};
